import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

type AdVisibilityObserverProps = {
    onVisibilityChangeCallback: (isVisible: boolean) => void;
    adSlotId: string;
    children: React.ReactNode;
}

export const AdVisibilityObserver = ({ onVisibilityChangeCallback, children, adSlotId  }: AdVisibilityObserverProps) => {
    const { ref, inView, entry } = useInView({
        threshold: 0.5
    });

    useEffect(() => {
        onVisibilityChangeCallback?.(inView);
    }, [inView]);
    
    return (
        <div ref={ref}>
            {children}
        </div>
    );
};